<template>
	<component :is="tag" class="current-user">
		<template v-if="currentUser">
			<slot :user="currentUser">
				<span class="current-user__name">{{ displayName }}</span>
			</slot>
		</template>
	</component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { authGetters } from '@/store/modules/auth';

export default defineComponent({
	props: {
		tag: {
			type: String,
			default: 'div',
		},

		field: {
			type: String,
			default: 'name',
		},

		filter: {
			type: Function,
			default: null,
		},
	},

	computed: {
		...authGetters.map(['currentUser']),

		displayName(): string {
			const val = (this.currentUser as any)?.[this.field] || '';

			return this.filter ? this.filter(val) : val;
		},
	},
});
</script>
